import React from 'react';
import { Grid, Button, Divider } from '@mui/material';
import {
    LocalShipping,
    CheckBox,
    CheckBoxOutlineBlank
} from '@mui/icons-material';
import { BoolField } from '../../CommonComponents/Form';
import { SectionDivider } from '../../CommonComponents';
import { METADATA_TYPES } from '../../../types/index';
import { hasStandardProperty, changeStandardProperty } from '../../../utils/metadata';

interface VehicleBlockProps {
    entity: any;
    onChange: (e: any) => void;
    settables: string[];
}

const VehicleBlock = ({
    entity,
    onChange,
    settables = []
}: VehicleBlockProps) => {
    const [selected, setSelected] = React.useState<'all' | 'some' | 'none'>('some');

    React.useEffect(() => {
        if (settables.every((veh) => entity.vehicleTypes?.includes(veh))) {
            setSelected('all');
        } else if ((entity.vehicleTypes?.length ?? 0) === 0) {
            setSelected('none');
        } else {
            setSelected('some');
        }
    }, [entity.vehicleTypes, settables]);

    const selectAll = () => {
        const currentVeh = entity.vehicleTypes || [];
        const newVeh = Array.from(new Set([...currentVeh, ...settables]));
        onChange({ ...entity, vehicleTypes: newVeh });
    };

    const selectNone = () => {
        const currentVeh = entity.vehicleTypes || [];
        const newVeh = currentVeh.filter((veh: string) => !settables.includes(veh));
        onChange({ ...entity, vehicleTypes: newVeh });
    };

    return (
        <Grid item lg={12} xl={6}>
            <SectionDivider
                label={`Fordonstyper (${entity.vehicleTypes?.length || 0})`}
                icon={<LocalShipping fontSize="small" />}
                marginTop={2}
                marginBottom={0}
            />
            <Grid container spacing={1} sx={{ mb: 1 }}>
                <Grid item>
                    <Button
                        size="small"
                        variant="text"
                        onClick={() => selectAll()}
                        startIcon={selected === 'all' ? <CheckBox /> : <CheckBoxOutlineBlank />}
                        sx={{ fontWeight: 300 }}
                    >
                        Alla
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        size="small"
                        variant="text"
                        onClick={() => selectNone()}
                        startIcon={selected === 'none' ? <CheckBox /> : <CheckBoxOutlineBlank />}
                        sx={{ fontWeight: 300 }}
                    >
                        Inga
                    </Button>
                </Grid>
            </Grid>
            <Divider sx={{ mb: 2, width: '160px' }} />
            <Grid container spacing={1}>
                {settables.map((veh: string) => (
                    <Grid item xs={4} key={veh}>
                        <BoolField
                            name={veh}
                            label={veh}
                            value={hasStandardProperty({ array: entity.vehicleTypes, value: veh })}
                            onChange={() => changeStandardProperty({
                                key: METADATA_TYPES.VEHICLE_TYPES,
                                array: entity.vehicleTypes,
                                value: veh,
                                entity,
                                onChange
                            })}
                        />
                    </Grid>
                ))}
            </Grid>
        </Grid>
    );
};

export default React.memo(VehicleBlock);
